import Splide from '@splidejs/splide';

/**
 * Changing the menus to cards
 */
(() => {
  const categoryCardsWrapper = document.querySelector('.category-cards-wrapper');
  if (!categoryCardsWrapper) return;

  categoryCardsWrapper.classList.remove('hide');

  // Changing the li's to div's
  categoryCardsWrapper.querySelectorAll('li')
    .forEach((category) => {
      const categoryCard = document.createElement('a');
      categoryCard.classList.add('card-wrapper');
      categoryCard.setAttribute('tabindex', 0);
      categoryCard.setAttribute('href', category.querySelector('ul > li > a')?.href);
      categoryCard.innerHTML = category.innerHTML;
      category.replaceWith(categoryCard);
    });

  // Moving all of the card-wrappers to the category-cards-wrapper
  const cardWrappers = categoryCardsWrapper.querySelectorAll('.card-wrapper');
  cardWrappers.forEach((cardWrapper) => {
    categoryCardsWrapper.appendChild(cardWrapper);
  });

  // Creating the image-wrapper div inside the card-wrapper
  cardWrappers.forEach((cardWrapper) => {
    const imageWrapper = document.createElement('div');
    imageWrapper.classList.add('image-wrapper');
    cardWrapper.prepend(imageWrapper);
  });

  // Moving the card images to the image-wrapper
  const images = categoryCardsWrapper.querySelectorAll('.card-wrapper .category-card-image img');
  images.forEach((image) => {
    const imageWrapper = image.closest('.card-wrapper').querySelector('.image-wrapper');
    imageWrapper.appendChild(image);

    const initialOverlay = document.createElement('div');
    initialOverlay.classList.add('initial-overlay');
    imageWrapper.appendChild(initialOverlay);

    const hoverOverlay = document.createElement('div');
    hoverOverlay.classList.add('hover-overlay');
    imageWrapper.appendChild(hoverOverlay);
  });

  // Creating the title-wrapper div inside the card-wrapper
  cardWrappers.forEach((cardWrapper) => {
    const titleWrapper = document.createElement('div');
    titleWrapper.classList.add('title-wrapper');
    cardWrapper.appendChild(titleWrapper);
  });

  // Moving the anchor to the title-wrapper and adding a class to it
  const titles = categoryCardsWrapper.querySelectorAll('.card-wrapper > a');
  titles.forEach((title) => {
    const titleWrapper = title.closest('.card-wrapper').querySelector('.title-wrapper');
    const titleParagraph = document.createElement('h2');
    titleParagraph.classList.add('category-link');
    titleParagraph.textContent = title.textContent;
    titleWrapper.appendChild(titleParagraph);
    title.remove();
  });

  // Moving the icons to the title-wrapper
  const icons = categoryCardsWrapper.querySelectorAll('.card-wrapper .category-card-icon img');
  icons.forEach((icon) => {
    const titleWrapper = icon.closest('.card-wrapper').querySelector('.title-wrapper');
    titleWrapper.prepend(icon);
  });

  // Removing the .submenu where the images were (ul)
  const submenuImages = categoryCardsWrapper.querySelectorAll('.card-wrapper ul');
  submenuImages.forEach((submenuImage) => {
    submenuImage.remove();
  });

  // Removing the .hasSubmenus element
  const hasSubmenus = categoryCardsWrapper.querySelector('.hasSubmenus');
  hasSubmenus.remove();

  // Creating a button that links to the category page
  const shopNowLink = categoryCardsWrapper.querySelector('.card-wrapper .category-link').href;
  categoryCardsWrapper.querySelectorAll('.card-wrapper .title-wrapper')
    .forEach((titleWrapper) => {
      const shopNow = document.createElement('button');
      shopNow.classList.add('btn-custom', 'secondary', 'shop-now');
      shopNow.setAttribute('href', shopNowLink);
      shopNow.innerHTML = 'Shop Now';
      titleWrapper.appendChild(shopNow);
    });

  // Add the link to the card-wrapper
  categoryCardsWrapper.querySelectorAll('.card-wrapper')
    .forEach((cardWrapper) => {
      // Click
      cardWrapper.addEventListener('click', () => {
        window.location.href = shopNowLink;
      });

      // Keydown
      cardWrapper.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          window.location.href = shopNowLink;
        }
      });
    });
})();

/**
 * Adding the slider to the cards
 */
(() => {
  document.querySelectorAll('.category-cards-wrapper')
    .forEach((widget) => {
      widget.classList.add('splide');

      // Add the splide-track
      const splideTrack = document.createElement('div');
      splideTrack.classList.add('splide__track');
      widget.appendChild(splideTrack);

      // Add the splide-list
      const splideList = document.createElement('div');
      splideList.classList.add('splide__list');
      splideTrack.appendChild(splideList);

      // Move the card-wrappers to the splide-list
      const cardWrappers = widget.querySelectorAll('.card-wrapper');
      cardWrappers.forEach((cardWrapper) => {
        splideList.appendChild(cardWrapper);
        cardWrapper.classList.add('splide__slide');
      });

      // Adding the arrows and pagination
      widget.innerHTML += /* html */ `
        <div class="splide__arrows">
          <button class="splide__arrow splide__arrow--prev"></button>
          <ul class="splide__pagination"></ul>
          <button class="splide__arrow splide__arrow--next"></button>
        </div>
      `;
    });
})();

/**
 * Slider settings
 */
(() => {
  document.querySelectorAll('.category-cards-wrapper')
    .forEach((item) => {
      const cardAmount = item.querySelectorAll('.splide__slide').length;

      const slider = new Splide(item, {
        type: 'slide', // 'slide', 'loop' or 'fade'
        perPage: 6, // how many items to show
        perMove: 1, // how many items to show when clicking next/prev
        gap: 30, // space between items
        pagination: cardAmount > 6, // show dots only if more than 4 slides
        arrows: cardAmount > 6, // show arrows only if more than 4 slides
        autoplay: false, // turn it on
        setInterval: 5000, // time between slides
        drag: cardAmount > 6, // disable drag if all slides are visible
        breakpoints: {
          1823: {
            perPage: 5,
            pagination: cardAmount > 5,
            arrows: cardAmount > 5,
            drag: cardAmount > 5,
          },
          1700: {
            perPage: 4,
            pagination: cardAmount > 4,
            arrows: cardAmount > 4,
            drag: cardAmount > 4,
          },
          1260: {
            perPage: 3,
            pagination: cardAmount > 3,
            arrows: cardAmount > 3,
            drag: cardAmount > 3,
          },
          1024: {
            perPage: 2,
            pagination: cardAmount > 2,
            arrows: cardAmount > 2,
            drag: cardAmount > 2,
          },
          768: {
            perPage: 1,
            pagination: cardAmount > 1,
            arrows: cardAmount > 1,
            drag: cardAmount > 1,
          },
        },
      });
      slider.mount();
    });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
